module.exports = __webpack_public_path__ + "4fd4e641d5c132c490b20c1be9d5b73b.svg";